import './BrandLogo.css'

import { Link } from 'react-router'

import { cx } from '../utilities/cx'

export type BrandLogoLayout = 'full' | 'mark' | 'wordmark'
export type BrandLogoSize = 'sm' | 'md' | 'lg'

export type BrandLogoProps = {
  className?: string
  /** full = mark + wordmark; mark / wordmark for A/B */
  layout?: BrandLogoLayout
  size?: BrandLogoSize
  /** Inverse/sidebar chrome colors */
  onChrome?: boolean
  /** Internal route; omit for non-link or use href for external */
  to?: string
  href?: string
}

/**
 * Revel Club brand lockup (gold “R” seal + wordmark).
 *
 * Link targets by context:
 * - Member app chrome: `to="/profile")`
 * - Staff chrome: `to("/staff/dashboard")`
 * - Auth / external pages: `href` → landing (`https://revel.club` or localhost:3051 in dev)
 */
export function BrandLogo(props: BrandLogoProps) {
  const { className, layout = 'full', size = 'md', onChrome = false, to, href } = props

  const classes = cx(
    'brand-logo',
    `brand-logo--${size}`,
    layout === 'mark' && 'brand-logo--mark-only',
    layout === 'wordmark' && 'brand-logo--wordmark-only',
    onChrome && 'brand-logo--on-chrome',
    className,
  )

  const mark = (
    <span className="brand-logo__mark" aria-hidden={layout === 'wordmark'}>
      <span className="brand-logo__mark-letter">R</span>
    </span>
  )
  const wordmark = (
    <span className="brand-logo__wordmark">
      <span className="brand-logo__name">
        Revel <span className="brand-logo__name-club">Club</span>
      </span>
    </span>
  )

  if (to) {
    return (
      <Link to={to} className={classes} aria-label="Revel Club">
        {mark}
        {wordmark}
      </Link>
    )
  }

  if (href) {
    return (
      <a href={href} className={classes} aria-label="Revel Club">
        {mark}
        {wordmark}
      </a>
    )
  }

  return (
    <div className={classes} aria-label="Revel Club">
      {mark}
      {wordmark}
    </div>
  )
}
